<template>
	<div class="p-he">
		<div class="p-he-tit">
			<div class="title">{{ baseData.title }}</div>
			<div class="subtitle">{{ baseData.subtitle }}</div>
		</div>
		<div class="p-he-box">
			<div class="p-he-box-imgs">
        <VueSlickCarousel v-bind="settings" ref="carousel">
          <div
            class="img"
            v-for="(item, i) in baseData.introduceList"
            :key="i"
            @click="tabClick(i)"
          >
            <img :src="supportWebp ? item.icon : item.pngIcon" alt="">
          </div>
        </VueSlickCarousel>
			</div>
			<div class="p-he-box-tabs">
				<div
					class="tab"
					:class="{ active: activeItem.index === i }"
					v-for="(item, i) in baseData.introduceList"
					:key="i"
					@click="tabClick(i)"
				>
					<div class="title">{{ item.title }}</div>
					<div class="desc">{{ item.desc }}</div>
					<div class="hr"></div>
					<div
            :style="hrStyle(i)"
						class="hr-active"
					></div>
				</div>
			</div>
		</div>
		<div class="p-he-list">
			<div
				v-for="(item, i) in baseData.introduceList"
				:key="i"
			>
				<p class="title">{{item.title}}</p>
				<p class="desc">{{item.desc}}</p>
				<img class="icon" :src="supportWebp ? item.icon : item.pngIcon" alt="">
			</div>
		</div>
	</div>
</template>

<script>
import { eduData } from '../config';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
	name: 'work-component',
  components: {VueSlickCarousel},
	data() {
		return {
			supportWebp: localStorage.isSupportWebp === 'true',
			baseData: eduData,
			animations: {
				time: 8,
				timer: null
			},
			activeItem: {
				index: -1,
				time: 0
			},
      settings: {
        arrows: false,
        dots: false,
        vertical: true,
				draggable: false
        // lazyLoad: true, // 懒加载，只能初次有效
      },
		};
	},
  computed: {
    hrStyle () {
      return function(i) {
        return {
          height: (this.activeItem.index === i ? 100 : 0) + '%',
          transition: (this.activeItem.index === i ? `all ${this.animations.time + 2}s` : '')
        }
      }
    }
  },
	methods: {
		tabClick(i) {
			if (this.activeItem.index === i) return;
      this.$refs.carousel && this.$refs.carousel.goTo(i)
			this.activeItem = {
				...this.activeItem,
				index: i,
				time: 0
			};
			this.init();
		},
		tabNext() {
			let index = this.activeItem.index;
			index++;
			if (index >= this.baseData.introduceList.length) {
				index = 0;
			}
			this.tabClick(index);
		},
		init() {
			if (this.animations.timer) clearInterval(this.animations.timer);
			this.animations.timer = setInterval(() => {
				this.activeItem = {
					...this.activeItem,
					time: ++this.activeItem.time
				};
				if (this.animations.time < this.activeItem.time) {
					clearInterval(this.animations.timer);
					this.animations.timer = null;
					this.tabNext();
				}
			}, 1000);
		}
	},
	mounted() {
    setTimeout(()=> {
      this.tabClick(0)
    }, 1000)
	}
};
</script>

<style lang="scss" scoped>
.p-he {
	width: 1200px;
	min-height: 764px;
	margin: 0 auto;
	padding-top: 86px;
	@media screen and (max-width: $width-l) {
    width: 100%;
  }
	&-tit {
		text-align: center;
		.title {
			font-weight: 700;
			font-size: 36px;
			line-height: 48px;
			color: rgba(13, 13, 13, 0.9);
		}
		.subtitle {
			font-weight: 400;
			font-size: 14px;
			line-height: 22px;
			color: rgba(13, 13, 13, 0.66);
			margin-top: 16px;
		}
	}
	&-box {
		width: 100%;
		min-height: 500px;
		margin-top: 44px;
		position: relative;
		display: flex;
		align-items: center;
		@include responsive($width-s) {
			display: none;
		}
		&-imgs {
			width: 722px;
      .img{
        width: 100%;
        img{
          width: 100%;
          height: 100%;
        }
      }
			@include responsive($width-l) {
        width: calc(100% - 470px);
        max-width: 722px;
      }
			@include responsive($width-m) {
        width: calc(100% - 470px);
        max-width: 722px;
      }
		}
		&-tabs {
			width: 442px;
			height: 370px;
			position: absolute;
			right: 0;
			top: 50%;
			transform: translate(0, -50%);
			.tab {
				width: 100%;
				height: 104px;
				padding-left: 20px;
				position: relative;
				cursor: pointer;
				& + .tab {
					margin-top: 40px;
				}
				.title {
					font-weight: 600;
					font-size: 20px;
					line-height: 32px;
					color: rgba(13, 13, 13, 0.9);
				}
				.desc {
					font-weight: 400;
					font-size: 14px;
					line-height: 22px;
					color: rgba(13, 13, 13, 0.66);
					margin-top: 6px;
				}
				.hr {
					position: absolute;
					width: 4px;
					height: 100%;
					left: 0px;
					top: 0px;
					background: rgba(13, 13, 13, 0.1);
					border-radius: 2px;
				}
				.hr-active {
					position: absolute;
					width: 4px;
					height: 0%;
					left: 0px;
					top: 0px;
					background: #2953c8;
					border-radius: 2px;
          
				}
			}
		}
	}
	&-list{
		width: 100%;
		padding: 0 32px;
		margin-top: 50px;
		display: none;
		@include responsive($width-s) {
			display: block;
		}
		.title{
			font-weight: 600;
			font-size: 20px;
			line-height: 32px;
			color: rgba(13, 13, 13, 0.9);
		}
		.desc{
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			line-height: 22px;
			color: rgba(13, 13, 13, 0.66);
			margin-top: 6px;
		}
		.icon{
			width: 100%;
		}
	}
}
</style>
